module.exports = __webpack_public_path__ + "media/images/features/5/history-1-75237b8d0154d49358e3c5414068fa9d.jpg";